// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4r-0";
export var eligibilityCardNotEligible = "_4r-1";